(function () {
  'use strict';

  var prefetched = new Set();
  var maxPrefetches = 8;
  var productPathPattern = /^\/products\/[^/?#]+\/?$/;

  function connectionAllowsPrefetch() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    return !/2g/.test(connection.effectiveType || '');
  }

  function normalizeUrl(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isPrefetchableProductUrl(url) {
    if (!url || url.origin !== window.location.origin) return false;
    if (!productPathPattern.test(url.pathname)) return false;
    if (url.href === window.location.href) return false;
    return true;
  }

  function prefetchProductPage(href) {
    if (!connectionAllowsPrefetch() || prefetched.size >= maxPrefetches) return;

    var url = normalizeUrl(href);
    if (!isPrefetchableProductUrl(url)) return;

    var cacheKey = url.pathname;
    if (prefetched.has(cacheKey)) return;
    prefetched.add(cacheKey);

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    document.head.appendChild(link);
  }

	  function bindProductLinkPrefetch(root) {
	    var scope = root && root.querySelectorAll ? root : document;
	    var links = scope.querySelectorAll('a[href*="/products/"]');

    links.forEach(function (link) {
      if (link.dataset.productPrefetchBound === 'true') return;
      link.dataset.productPrefetchBound = 'true';

      ['pointerenter', 'focus', 'touchstart', 'mousedown'].forEach(function (eventName) {
        link.addEventListener(eventName, function () {
          prefetchProductPage(link.href);
        }, { once: true, passive: true });
      });
	    });
	  }

	  function playDeferredVideo(video) {
	    if (!video || video.dataset.deferredVideoLoaded === 'true') return;
	    video.dataset.deferredVideoLoaded = 'true';
	    video.load();
	    if (video.dataset.deferredAutoplay !== 'true') return;
	    var playPromise = video.play();
	    if (playPromise && playPromise.catch) {
	      playPromise.catch(function () {});
	    }
	  }

	  function bindDeferredVideos(root) {
	    var scope = root && root.querySelectorAll ? root : document;
	    var videos = scope.querySelectorAll('video.js-deferred-video');
	    if (!videos.length) return;

	    if (!('IntersectionObserver' in window)) {
	      videos.forEach(playDeferredVideo);
	      return;
	    }

	    var observer = new IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        if (!entry.isIntersecting) return;
	        playDeferredVideo(entry.target);
	        observer.unobserve(entry.target);
	      });
	    }, { rootMargin: '500px 0px' });

	    videos.forEach(function (video) {
	      if (video.dataset.deferredVideoBound === 'true') return;
	      video.dataset.deferredVideoBound = 'true';
	      observer.observe(video);
	    });
	  }

	  function init() {
	    bindProductLinkPrefetch(document);
	    bindDeferredVideos(document);
	  }

	  window.NisPerformance = window.NisPerformance || {};
	  window.NisPerformance.bindProductLinkPrefetch = bindProductLinkPrefetch;
	  window.NisPerformance.bindDeferredVideos = bindDeferredVideos;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

	  document.addEventListener('shopify:section:load', function (event) {
	    bindProductLinkPrefetch(event.target);
	    bindDeferredVideos(event.target);
	  });
	})();
